import { Component } from '@angular/core';
import { StoreService } from 'avn/services/store.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  constructor(private store: StoreService) {}

  getWellbeingURL() {
    const location = this.store.meraLocation;
    return [
      `/search/health-and-wellbeing-services/${location.city_name.toLowerCase().replace(/ /g, '-')}/${
        location.post_code
      }`
    ];
  }
}
